/* eslint-disable */
<template>
  <div id="contactform" class="contactform">
    <div class="container-fluid">
      <h1>Message Us</h1>
      <form class="contact-form" @submit.prevent="submitContactForm" novalidate="true">
        <div class="alert alert-success" v-if="successContactMessage">
          <p>
            Your Message was sent.
            <br />We will contact you shortly
          </p>
        </div>
        <ul class="alert alert-danger" v-if="contactErroes.length">
          <li
            class="text-danger pl-2"
            style="margin-left: 12px; text-align: left;"
            v-for="error in contactErroes"
            :key="error"
          >{{ error }}</li>
        </ul>
        <div class="row">
          <div class="form-group col-md-6">
            <p>Your Full Name</p>
            <input type="text" v-model="fullname" class="form-control" placeholder="Your Name" />
          </div>
          <div class="form-group col-md-6">
            <p>E-mail</p>
            <input type="email" v-model="email" class="form-control" placeholder="Your E-mail" />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <p>Phone Number</p>
            <input type="tel" v-model="phone" class="form-control" placeholder="Phone no" />
          </div>
          <div class="form-group col-md-6">
            <p>Subject</p>
            <input type="text" v-model="subject" class="form-control" placeholder="Subject" />
          </div>
        </div>
        <div class="form-group">
          <p>Message</p>
          <textarea class="form-control" v-model="message" rows="6" placeholder="Your Message"></textarea>
        </div>
        <input type="submit" class="btn btn-dark" value="Submit" />
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
  data() {
    return {
      fullname: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
      contactErroes: [],
      Erros: false,
      successContactMessage: false
    };
  },
  methods: {
    submitContactForm() {
      // Validate all form inputs

      // remove all errors and messages
      this.contactErroes = [];
      this.successContactMessage = false;

      // send error message if fields are empty
      if (!this.fullname) {
        this.contactErroes.push("Fullname is required");
        return false;
      }
      if (!this.email) {
        this.contactErroes.push("E-mail is required");
        return false;
      }

      if (!this.validEmail(this.email)) {
        this.contactErroes.push("Valid email is required");
        return false;
      }

      if (!this.subject) {
        this.contactErroes.push("Subject number is required");
        return false;
      }

      if (!this.phone) {
        this.contactErroes.push("Phone number is required");
        return false;
      }

      if (isNaN(this.phone)) {
        this.contactErroes.push("Phone number must be number");
        return false;
      }

      if (!this.message) {
        this.contactErroes.push("Please fill out your message");
        return false;
      } else {
        // send form if fields are not empty
        this.successContactMessage = true;
        // clear error messages
        this.contactErroes = [];
        this.clearFormMsg();
        // remove success message after 8seconds
        setTimeout(() => (this.successContactMessage = false), 8000);
        return true;
      }
    },

    // email validation
    validEmail: function(email) {
      var emailReg = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      return emailReg.test(email);
    },
    clearFormMsg() {
      this.fullname = "";
      this.email = "";
      this.phone = "";
      this.subject = "";
      this.message = "";
    }
  }
};
</script>

<style></style>
